var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 6.66667H20V4H22.6667V6.66667ZM20 20V28L23.0533 24.9467L26.12 28L28 26.12L24.9467 23.0667L28 20H20ZM25.3333 12H28V9.33333H25.3333V12ZM25.3333 17.3333H28V14.6667H25.3333V17.3333ZM14.6667 28H17.3333V25.3333H14.6667V28ZM9.33333 6.66667H12V4H9.33333V6.66667ZM4 22.6667H6.66667V20H4V22.6667ZM6.66667 28V25.3333H4C4 26.8 5.2 28 6.66667 28ZM25.3333 4V6.66667H28C28 5.2 26.8 4 25.3333 4ZM14.6667 6.66667H17.3333V4H14.6667V6.66667ZM4 12H6.66667V9.33333H4V12ZM9.33333 28H12V25.3333H9.33333V28ZM4 17.3333H6.66667V14.6667H4V17.3333ZM4 6.66667H6.66667V4C5.2 4 4 5.2 4 6.66667Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSelect);
export default __webpack_public_path__ + "static/media/box-select.cff2301f.svg";
export { ForwardRef as ReactComponent };